import Index from "@/views/faq/index";
// import FAQ from "@/views/faq/FAQAr";

const URL_PREFIX = "faq";
const CODE = "faq";

const routes = [
  {
    path: `${URL_PREFIX}`,
    name: `${CODE}.index`,
    component: Index,
  },
];

export default routes;
